// format: (111) 111-1111
// export const phoneNumberRegex = /^\(\d{3}\)\s\d{3}-\d{4}$/;
export const zipCodeRegex = /^\d{5}$/;
export const passwordRegex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{6,16}$/;
// only hyphens, parentheses, spaces, and numbers are allowed
export const flexiblePhoneNumberRegex = /^[\d()+\- ]+$/;
export const e164PhoneRegex = /^\+[1-9]\d{1,14}$/;
export const supplierNpiRegex = /^\d{10}$/;
